import { api_configuration } from "../../common";
import csr = api_configuration.types.client_state.alan_api;
import csd = api_configuration.types.client_state.alan_api;

export default function (node: csr.Cnode): csd.Tclient_id_path {
	return createClientIdPath(node, { "has steps": ["no", {}] });
}

function createClientIdPath(node: csr.Cnode, raw_path: csd.Tclient_id_path): csd.Tclient_id_path {
	return node.input.position().switch({
		root: ($) =>
			$.switch({
				root: () => raw_path,
				operation: ($) =>
					createClientIdPath($.parent.parent.parent, {
						"has steps": [
							"yes",
							{
								type: [
									"operation",
									{
										operation: $.parent.parent.key.entry,
									},
								],
								tail: raw_path,
							},
						],
					}),
			}),
		entity: ($) =>
			$.switch({
				root: () => raw_path,
				entry: function ($) {
					const entry_key = $.key;
					const collection_name = $.parent.parent.parent.key.entry;
					return createClientIdPath($.parent.parent.parent.parent, {
						"has steps": [
							"yes",
							{
								type: [
									"collection entry",
									{
										collection: collection_name,
										entry: entry_key,
									},
								],
								tail: raw_path,
							},
						],
					});
				},
			}),
		group: ($) => {
			const group_name = $.parent.parent.key.entry;
			return createClientIdPath($.parent.parent.parent, {
				"has steps": [
					"yes",
					{
						type: [
							"group",
							{
								group: group_name,
							},
						],
						tail: raw_path,
					},
				],
			});
		},
		state: ($) => {
			const state_name = $.key.entry;
			const state_group_name = $.parent.parent.parent.key.entry;
			return createClientIdPath($.parent.parent.parent.parent, {
				"has steps": [
					"yes",
					{
						type: [
							"state",
							{
								"state group": state_group_name,
								state: state_name,
							},
						],
						tail: raw_path,
					},
				],
			});
		},
	});
}
